import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 韩漫网免费在线漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50">
            {comic.status}
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50">
            {comic.status}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-xs text-white/90 line-clamp-2">{comic.description}</p>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
        {comic.title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-400">{comic.author}</span>
        <span className="flex items-center text-xs text-foreground-500">
          <i className="ri-star-fill text-accent-500 mr-0.5 text-xs"></i>
          {comic.rating}
        </span>
      </div>
    </Link>
  );
}